import SectionHead from "./SectionHead";
import { collectionFeature, collectionList } from "@/mocks/homeContent";

export default function Collections() {
  return (
    <section id="collections" className="w-full scroll-mt-24 bg-[#efe7d5]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-16 md:px-6 md:py-24">
        <SectionHead
          eyebrow="VAULT PICKS · 干货家底"
          title="压箱底的干货，值得放一起"
          desc="除了单档存货，黑料舍还会把同一主题的高翻内容攒成合集，越攒越厚，想一次看够就来这里翻。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {/* big feature collection */}
          <article className="group relative flex flex-col justify-between overflow-hidden rounded-xl border border-[#dccdae] bg-white p-7 md:p-9">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -right-6 -top-10 font-editorial text-[120px] font-semibold italic leading-none text-[#f0e2c4] md:text-[150px]"
            >
              2025
            </div>
            <div className="relative">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#201b15] px-3 py-1 text-[11px] font-semibold tracking-wide text-[#e9c579]">
                <i className="ri-vip-diamond-fill text-[11px]" aria-hidden="true" />
                {collectionFeature.tag}
              </span>
              <h3 className="mt-5 max-w-sm font-song text-[24px] font-semibold leading-tight text-[#241f18] md:text-[28px]">
                {collectionFeature.title}
              </h3>
              <p className="mt-3 max-w-md text-[14px] leading-relaxed text-[#6d6149]">
                {collectionFeature.desc}
              </p>
            </div>
            <div className="relative mt-8 flex flex-wrap items-center justify-between gap-3 border-t border-[#ece2cd] pt-5">
              <span className="text-[13px] text-[#8a7a5c]">{collectionFeature.meta}</span>
              <a
                href="#newin"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-[#201b15] px-4 py-2 text-sm font-semibold text-[#e9c579] transition-colors hover:bg-[#322a20]"
              >
                翻这本合集
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
            </div>
          </article>

          {/* stacked small collections */}
          <div className="flex flex-col overflow-hidden rounded-xl border border-[#dccdae] bg-[#faf5ea]">
            {collectionList.map((c, i) => (
              <a
                key={c.no}
                href="#newin"
                className={`group flex items-center gap-4 px-6 py-5 transition-colors hover:bg-[#f2e9d3] md:gap-6 md:px-7 ${
                  i !== collectionList.length - 1 ? 'border-b border-[#e7dbc2]' : ''
                }`}
              >
                <span className="font-editorial text-xl italic text-[#c8a45f]">{c.no}</span>
                <div className="min-w-0 flex-1">
                  <h4 className="text-[16px] font-bold text-[#241f18]">{c.title}</h4>
                  <p className="mt-1 text-[13px] leading-relaxed text-[#6d6149]">{c.desc}</p>
                </div>
                <i
                  className="ri-arrow-right-line shrink-0 text-[#b3873a] transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}